<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <members-table :title="$t('member')"></members-table>
                    <!-- <div class="card shadow"
                        :class="type === 'dark' ? 'bg-default': ''">
                        <div class="card-header border-0"
                            :class="type === 'dark' ? 'bg-transparent': ''">
                        <div class="row align-items-center">
                            <div class="col">
                            <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
                                {{$t('member')}}
                            </h3>
                            </div>
                            <div class="col text-right">
                              <router-link :to="'/'+$i18n.locale+'/add_member'" class="text-light">
                                <base-button type="primary" size="md">{{$t('add')}}</base-button>
                              </router-link>
                            </div>
                        </div>
                        </div>
                        <div class="table-responsive">

                        <div class="overflow-auto">
                            <b-table
                            id="member-table"
                            :items="tableData"
                            :fields="fields"
                            :per-page="perPage"
                            :current-page="currentPage"
                            >
                            <template slot="img" slot-scope="row">
                                <div class="media align-items-center">
                                <a href="#" class="avatar rounded-circle mr-3">
                                    <img :src="row.item.img">
                                </a>
                                <div class="media-body">
                                    <span class="name mb-0 text-sm">{{row.item.title}}</span>
                                </div>
                                </div>
                            </template>
                            </b-table>

                            <div class="card-footer d-flex justify-content-end bg-transparent">
                                <b-pagination
                                    size="lg"
                                    v-model="currentPage"
                                    :total-rows="rows"
                                    :per-page="perPage"
                                    aria-controls="member-table"
                                ></b-pagination>
                            </div>

                        </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>

        <!-- <modal :show.sync="modal"
                :gradient="modal_setting.gradient"
                modal-classes="modal-danger modal-dialog-centered">
                <div class="py-3 text-center">
                    <i class="ni ni-bell-55 ni-3x"></i>
                    <h4 class="heading mt-4"></h4>
                    <p>{{modal_setting.alert_text}}</p>
                </div>

                <template slot="footer">
                    <base-button type="link"
                                text-color="white"
                                class="ml-auto"
                                @click="modal = false">
                        {{$t('close')}}
                    </base-button>
                </template>
            </modal> -->

    </div>
</template>
<script>
  // import i18n from "@/i18n"
  import MembersTable from './Tables/MembersTable'
  export default {
    name: 'member',
    /* props: {
      type: {
        type: String
      },
      title: String
    }, */
    components: {
      MembersTable
    }
    /* data() {
      return {
        modal: false,
        modal_setting: {
            alert_text: '',
            gradient: ''
        },
        perPage: 3,
        currentPage: 1,
        show_item: [],
        fields: [
          { key: 'img', label: 'Project' },
          { key: 'budget', label: 'Budget' },
          { key: 'status', label: 'Status' },
          { key: 'statusType', label: 'Users' },
          { key: 'completion', label: 'Completion' },
        ],
        tableData: [
          {
            img: '/img/theme/bootstrap.jpg',
            title: 'Argon Design System',
            budget: '$2500 USD',
            status: 'pending',
            statusType: 'warning',
            completion: 60
          },
          {
            img: '/img/theme/angular.jpg',
            title: 'Angular Now UI Kit PRO',
            budget: '$1800 USD',
            status: 'completed',
            statusType: 'success',
            completion: 100
          },
          {
            img: '/img/theme/sketch.jpg',
            title: 'Black Dashboard',
            budget: '$3150 USD',
            status: 'delayed',
            statusType: 'danger',
            completion: 72
          },
          {
            img: '/img/theme/react.jpg',
            title: 'React Material Dashboard',
            budget: '$4400 USD',
            status: 'on schedule',
            statusType: 'info',
            completion: 90
          },
          {
            img: '/img/theme/vue.jpg',
            title: 'Vue Paper UI Kit PRO',
            budget: '$2200 USD',
            status: 'completed',
            statusType: 'success',
            completion: 100
          }
        ]
      }
    },
    computed: {
      rows() {
          return this.tableData.length
      }
    },
    created () {
      this.ListItem()
    },
    methods: {
      modalAlert (req) {
            if(req) {
                this.modal_setting.alert_text = req.data.message
            } else {
                this.modal_setting.alert_text = "ERROR"
            }
            this.modal_setting.gradient = "danger"
            this.modal = true
      },
      ListItem () {
        this.show_item = []
        this.$http.get('members')
          .then(request => this.ListItemSuccessful(request))
          .catch(() => this.ListItemFailed())
      },
      ListItemSuccessful (req) {
        if (req.data.code !== '0') {
          this.ListItemFailed(req)
          return
        }
        for (var i = 0, l = req.data.data.data.length; i < l; i++) {
          this.show_item.push(req.data.data.data[i])
        }
      },
      ListItemFailed (req) {
        this.modalAlert(req)
      }
    } */
  }
</script>
<style></style>
